<template>
  <el-dialog :title="title"
             :visible.sync="modelValue"
             :close-on-click-modal="false"
             top="100px"
             @open="handleOpen"
             destroy-on-close
             append-to-body
             width="40%"
             :before-close="handleClose"
             custom-class="custom-dialog-class">
    <template #default >
      <div class="add-general-type-container" >
        <div class="form-container">
          <el-form
              :rules="rules"
              ref="formRef"
              label-width="100px"
              :model="form">
            <el-form-item label="类型名称：" prop="typeName">
              <el-input
                  v-model="form.typeName"
                  clearable
                  placeholder="请输入"
                  maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item label="图片：" prop="imageUrl">
              <PictureUpload ref="PictureUploadRef" v-model="form.imageUrl" />
            </el-form-item>
          </el-form>
        </div>
        <div class="footer-container">
          <el-button type="primary" @click="confirmHandler" >确 认</el-button>
          <el-button @click="handleClose(closeHandler)">取 消</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import PictureUpload from "../PictureUpload";
export default {
  name: "AddGeneralType",
  components: {
    PictureUpload,
  },
  props: {
    value: {
      type: Boolean,
      default: () => false
    },
    id: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      form: {
        typeName: "",
        imageUrl: "",
      },
      rules: {
        typeName: [
          { required: true, message: '请输入类型名称', trigger: 'blur' },
        ],
        imageUrl: [
          { required: true, message: '请上传图片', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    title() {
      let str = "添加参考图";
      if (this.id) {
        str = "编辑参考图";
      }
      return str
    },
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async getData() {
      try {
        const res = await this.$get(`imageCategory/findById/${this.id}`)
        if (!res) return false;
        const { data } = res;
        this.form.typeName = data.typeName;
        this.form.imageUrl = data.imageUrl;
        this.$refs.PictureUploadRef.setImage();
      }catch (e) {
        console.error(`获取回显数据失败`, e);
      }
    },
    handleOpen() {
      if (this.id) {
        this.getData();
      }
    },
    async confirmApi() {
      try {
        const res = await this.$post("imageCategory/addOrUpdate", {
          id: this.id,
          ...this.form
        })
        if (!res) return false;
        this.$message.success("提交成功");
        this.$emit("updateList");
        this.handleClose(this.closeHandler);
      }catch (e) {
        console.error(`提交失败`, e);
      }
    },
    confirmHandler() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.confirmApi();
        }
      });
    },
    closeHandler() {
      this.modelValue = false;
    },
    handleClose(done) {
      this.$refs.formRef.resetFields();
      done();
    },
  }
}

</script>

<style scoped lang="scss">
.add-general-type-container{

}
.form-container{
  height: 300px;
  .el-input{
    width: 260px;
  }
}
.footer-container{
  padding-top: 28px;
  border-top: 1px solid #EBECF0;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-button{
    width: 120px;
  }
  .el-button + .el-button{
    margin-left: 50px;
  }
}
</style>
